import {
	IConferencesResponse,
	IPlayoffPicture,
	IPositionResponse,
} from "data/providers/api/prediction.api.provider";
import {get, round, sum} from "lodash";
import {ILightPredictionNew} from "data/stores/light_predictions/light_predictions.store";
import {DEFAULT_LIGHT_PREDICTION} from "data/constants";

export const extractPredictionResponse = (
	data: IPlayoffPicture | null,
	nfcConferenceId: number,
	afcConferenceId: number
): ILightPredictionNew => {
	const conferences = get(data, "conferences", []) as IConferencesResponse[];
	const nfcConference = conferences.find((el) => el.conferenceId === nfcConferenceId);
	const afcConference = conferences.find((el) => el.conferenceId === afcConferenceId);
	const nfcPredictions = get(nfcConference, "positions", []) as IPositionResponse[];
	const afcPredictions = get(afcConference, "positions", []) as IPositionResponse[];

	return {
		nfc: DEFAULT_LIGHT_PREDICTION.nfc.map((prediction) => {
			const pick = nfcPredictions.find(({position}) => position === prediction.position);

			return {
				...prediction,
				squadId: pick?.squadId || prediction.squadId,
			};
		}),
		afc: DEFAULT_LIGHT_PREDICTION.afc.map((prediction) => {
			const pick = afcPredictions.find(({position}) => position === prediction.position);

			return {
				...prediction,
				squadId: pick?.squadId || prediction.squadId,
			};
		}),
	};
};

export const createPredictionPayload = (
	data: ILightPredictionNew,
	nfcConferenceId: number,
	afcConferenceId: number
) => {
	const {nfc, afc} = data;

	const nfcPayload = nfc.map((el) => {
		return {
			squadId: el.squadId,
			position: el.position,
		};
	});

	const afcPayload = afc.map((el) => {
		return {
			squadId: el.squadId,
			position: el.position,
		};
	});

	return {
		playoffPicture: {
			conferences: [
				{
					conferenceId: nfcConferenceId,
					positions: nfcPayload,
				},
				{
					conferenceId: afcConferenceId,
					positions: afcPayload,
				},
			],
		},
	};
};

export const getSquadPercent = (win: number, lose: number, tie: number) => {
	const playedCount = sum([win, lose, tie]);

	if (!playedCount) {
		return 0;
	}
	return round((win / playedCount) * 100, 2);
};
